// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2-Xuh","rootSmall":"AddTileButton_rootSmall__3u33q"};